<h2>Community Health: {{ healthMessage }}</h2>
<div>
  <div class="check-in-summary"
    *ngIf="barChartData"
    fxLayout="row"
    fxLayoutAlign="center">
    <div fxFlex="1 1 auto"
      fxFlexAlign="center">
      <img src="/assets/images/badges/excellent.png">
      <span fxFlex
        fxFlexAlign="center">{{ barChartData[0].data[0] }} </span>
    </div>
    <div fxFlex="1 1 auto"
      fxFlexAlign="center">
      <img src="/assets/images/badges/good.png">
      <span fxFlex
        fxFlexAlign="center">{{ barChartData[1].data[0] }} </span>
    </div>
    <div fxFlex="1 1 auto"
      fxFlexAlign="center">
      <img src="/assets/images/badges/fair.png">
      <span fxFlex
        fxFlexAlign="center">{{ barChartData[2].data[0] }} </span>
    </div>
    <div fxFlex="1 1 auto"
      fxFlexAlign="center">
      <img src="/assets/images/badges/poor.png">
      <span fxFlex
        fxFlexAlign="center">{{ barChartData[3].data[0] }} </span>
    </div>

  </div>
  <div style="display: block">
    <canvas baseChart
      height="180"
      [datasets]="barChartData"
      [colors]="barColors"
      [labels]="barChartLabels"
      [legend]="false"
      [options]="barOptions"
      [legend]="false"
      chartType="bar"></canvas>
  </div>

  <h2>Check Ins Over Time</h2>

  <div style="display: block">
    <canvas baseChart
      #lineChart
      height="200"
      [datasets]="lineChartData"
      [colors]="lineColors"
      [labels]="lineLabels"
      [legend]="false"
      [options]="lineOptions"
      chartType="line"></canvas>
  </div>
</div>